const DEV = process.env.NODE_ENV === 'development'

export default {
  init() {
    // Add tooltip also to dynamic elements
    $('body').tooltip({
      selector: '.starred',
    })

    $('.site-main-menu .has-mega-menu, .site-main-menu .mega-menu').hover(
      function () {
        $('.site-main-menu').addClass('mega-menu--open')
      },
      function () {
        $('.site-main-menu').removeClass('mega-menu--open')
      }
    )

    $('.site-mobile-menu .menu-item-has-children>a').bind(
      'click',
      function (e) {
        e.preventDefault()
        var tg = $(this).next('.sub-menu').slideToggle()
      }
    )
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    console.log('finalize common')
  },
}
